import { Directive, HostBinding } from '@angular/core';
@Directive({
  selector: '[bui-thead]'
})

export class DataTheadDirective {
  @HostBinding(`class.ant-table-thead`) true;

  constructor() {}
}
